import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { IconKey } from '../../../../../../whitelabel/icon-key.enum';
import { IconPipe } from '../../../../../shared/pipes/icon.pipe';
import { IconComponent } from '../../../icon/icon/icon.component';

@Component({
  selector: 'osp-dialog-close-icon',
  templateUrl: './dialog-close-icon.component.html',
  standalone: true,
  imports: [IconComponent, IconPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DialogCloseIconComponent {
  @HostBinding('class') protected hostClass = 'osp-dialog-close-icon';
  readonly IconKey = IconKey;
}
